import React, { useContext } from 'react';
import { ModalsContext, MODAL_TYPES } from 'components/context/ModalsContext';
import NoAdsConnectedModal from 'components/modals/NoAdsConnectedModal';
import UpsellModal from 'components/modals/UpsellModal';
import ConnectGoogleAdsAccountModal from 'components/modals/ConnectGoogleAdsAccountModal';
import ConnectMetaAdsAccountModal from 'components/modals/ConnectMetaAdsAccountModal';
import PlansModal from 'components/PlansModal';
import ConnectionsModal from 'components/ConnectionsModal';
import UpdateBusinessDataModal from 'components/modals/UpdateBusinessDataModal';
import CreateObjectivesSetupModal from 'components/modals/CreateObjectivesSetupModal';

export const ModalsRenderer = () => {
  const ctx = useContext(ModalsContext);
  if (!ctx) {
    return null;
  }
  const { currentModal, closeModal, upsellModalConfig, objectivesSetupModalConfig } = ctx;

  const renderModal = () => {
    switch (currentModal) {
      case MODAL_TYPES.NO_ADS_CONNECTED:
        return <NoAdsConnectedModal isOpen={true} onClose={closeModal} />;
      
      case MODAL_TYPES.UPSELL:
        return <UpsellModal isOpen={true} onClose={closeModal} config={upsellModalConfig} />;
      
      case MODAL_TYPES.CONNECT_GOOGLE_ADS_ACCOUNT:
        return <ConnectGoogleAdsAccountModal isOpen={true} onClose={closeModal} />;
      
      case MODAL_TYPES.CONNECT_META_ADS_ACCOUNT:
        return <ConnectMetaAdsAccountModal isOpen={true} onClose={closeModal} />;

      case MODAL_TYPES.PLANS:
        return <PlansModal isOpen={true} onClose={closeModal} />;

      case MODAL_TYPES.CONNECTIONS:
        return <ConnectionsModal isOpen={true} onClose={closeModal} />;

      case MODAL_TYPES.UPDATE_BUSINESS_DATA:
        return <UpdateBusinessDataModal isOpen={true} onClose={closeModal} />;

      case MODAL_TYPES.CREATE_OBJECTIVES_SETUP:
        return (
          <CreateObjectivesSetupModal
            isOpen={true}
            onClose={closeModal}
            platform={objectivesSetupModalConfig?.platform}
            mandatoryUntilGenerated={Boolean(objectivesSetupModalConfig?.mandatoryUntilGenerated)}
          />
        );

      case MODAL_TYPES.NONE:
      default:
        return null;
    }
  };

  return renderModal();
}; 